export class EventBusLogger {
  static $inject = ['eventBus'];

  constructor(eventBus) {
    const fire = eventBus.fire.bind(eventBus);

    eventBus.fire = (type, data) => {
    //  console.log(type, data);

      fire(type, data);

    };
  }
  /* use eventBusLogger
    this.bpmnJS = new Modeler({
      keyboard: {
        bindTo: document
      },
      additionalModules: [
        {
          __init__: ["eventBusLogger"],
          eventBusLogger: ["type", EventBusLogger]
        }
      ]
    });

   */
}
